import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root',
})
export class LeaveService {
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  async getApplyResult(
    title: any,
    leave_type_id: any,
    start_date: any,
    end_date: any,

    leave_payment_status: any,
    description: any,
    shortLeave: any,
    leave_name: any,
    source: any,
    selectedUserId: any,
    leave_action: any,
    leave_attachment: any,
    shortleave_end_time: any,
    shortleave_start_time: any,
    shortleave_time: any,
    _team_lead_action: any,
  ) {
    /**
     *
     * Get today date
     *
     */
    let today: any = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();

    today = mm + '-' + dd + '-' + yyyy;

    /**
     *
     * Make Form data
     *
     */
    const formData = {
      title: title,
      leave_type_id: leave_type_id,
      start_date: start_date,
      end_date: end_date,

      leave_payment_status: leave_payment_status,
      description: description,
      applied_date: today,
      short_leave: shortLeave,
      source: source,
      leave_name: leave_name,
      action_type: leave_action,
      member_id: selectedUserId,
      leave_doc: leave_attachment,
      shortLeave_start_time: shortleave_start_time,
      shortLeave_end_time: shortleave_end_time,
      shortLeave_hours: shortleave_time,
      approval_or_recommendation: _team_lead_action,
    };
    return this.httpClient
      .post(this.Customeroutes.getApplyLeave(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }


  async updateLeave(
    id: any,
     title: any,
    leave_type_id: any,
    start_date: any,
    end_date: any,

    leave_payment_status: any,
    description: any,
    shortLeave: any,
    leave_name: any,
    source: any,
    leave_action: any,
    leave_attachment: any,
    shortleave_end_time: any,
    shortleave_start_time: any,
    shortleave_time: any,
    _team_lead_action: any,

  ) {
    /**
     *
     * Get today date
     *
     */

    let today: any = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();

    today = mm + '-' + dd + '-' + yyyy;

    /**
     *
     * Make Form data
     *
     */

    const formData = {
      id: id,
      title: title,
      leave_type_id: leave_type_id,
      start_date: start_date,
      end_date: end_date,

      leave_payment_status: leave_payment_status,
      description: description,
      applied_date: today,
      short_leave: shortLeave,
      source: source,
      leave_name: leave_name,
      action_type: leave_action,
      leave_doc: leave_attachment,
      shortLeave_start_time: shortleave_start_time,
      shortLeave_end_time: shortleave_end_time,
      shortLeave_hours: shortleave_time,
      approval_or_recommendation: _team_lead_action,


    };
    return this.httpClient
      .post(this.Customeroutes.getUpdateLeave(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async deleteLeave(
    id: any
  ) {
    const formData = {
      id: id
    };
    return this.httpClient
      .post(this.Customeroutes.getDeleteLeave(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getLeaveFilter(
    _startdate: any,
    _enddate: any,
    _month: any,
    _attendance_tyoe: any
  ) {
    const postBody = {
      start_date: _startdate || '',
      end_date: _enddate || '',
      month: _month || '',
      attendance_type: _attendance_tyoe || '',
    };
    return this.httpClient
      .post(this.Customeroutes.getLeaveFilters(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getStatsFilter() {
    return this.httpClient
      .post(this.Customeroutes.getLeaveStats(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }
  async getAllLeave() {

    return this.httpClient
      .post(this.Customeroutes.getAllLeave(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getAllUserLeave(id: any) {
    const postBody = {
      id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.getAllUserLeave(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }



  async getLeaveMangement(_name: any, _start_date: any, _end_date: any, leavetype:any,leaveStatus:any,leaveCategory:any, leavePayment:any) {
    const postFilter = {
      name: _name || '',
      start_date: _start_date || '',
      end_date: _end_date || '',
      type: leavetype || '',
      status: leaveStatus || '',
      category: leaveCategory || '',
      payment_status: leavePayment || '',

    };
    return this.httpClient
      .post(this.Customeroutes.getLeaveMangement(), postFilter, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async getScreenShotTracker(_employmentId_trackerActivity: any, _date: any) {
    const postFilter = {
      employmentId_trackerActivity: _employmentId_trackerActivity,
      date: _date,

    };
    return this.httpClient
      .post(this.Customeroutes.getScreenShotFromTracker(), postFilter, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async backfillSingleUser(user_id: any, date: any) {
    const postBody = {
      user_id: user_id,
      date: date,
    };

    return this.httpClient
      .post(this.Customeroutes.backfillSingleUser(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async getLeaveApproved(id: any, status: any) {

    const postFilter = {
      id: id,
      status: status,

    };
    return this.httpClient
      .post(this.Customeroutes.leaveApproved(), postFilter, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async rejectLeave(leave_id: any, rejected_reason: any) {

    const postBody = {
      leave_id: leave_id || '',
      rejected_reason: rejected_reason || ''
    };
    return this.httpClient
      .post(this.Customeroutes.leaveReject(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async leaveReportFunction(_last_year_data: any, search_by_name: any) {
    const postBody = {
      last_year_data: _last_year_data || '',
      search_by_name: search_by_name || '',

    };
    return this.httpClient
      .post(this.Customeroutes.leaveReport(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async leavesReset() {
    return this.httpClient
      .post(this.Customeroutes.resetLeaves(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async updatedate(leave_id: any, updatestartdate: any, updateenddate: any) {

    const postBody = {
      id: leave_id,
      start_date: updatestartdate,
      end_date: updateenddate
    };
    return this.httpClient
      .post(this.Customeroutes.leaveupdate(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async redoLeave(leave_id: any, user_id: any) {

    const postBody = {
      id: leave_id,
      user_id: user_id
    };
    return this.httpClient
      .post(this.Customeroutes.leaveredo(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async getAbsents() {
    return this.httpClient
      .post(this.Customeroutes.getAbsents(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



async getcheckapplyLeave(
  leave_type_id:any,
  short_start_date:any,
  start_time:any,
  end_time:any,
  start_date:any,
  end_date:any
) {
   const postBody = {
      leave_type_id: leave_type_id,
      date_for_short_leave: short_start_date,
      start_time:start_time,
      end_time:end_time,
      start_date:start_date,
      end_date:end_date
    };
    return this.httpClient
      .post(this.Customeroutes.getcheckapplyLeave(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async checkLeaveLimit(selectedUserId: any, startDate: any) {
    const postBody = {
      user_id: selectedUserId || '',
      start_date: startDate || ''
    };
    return this.httpClient
      .post(this.Customeroutes.getCheckLeaveLimit(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async getfilterData(title: any, startDate: any, endDate: any) {

    const postBody = {
      leave_title: title,
      start_date: startDate,
      end_date: endDate,
    };
    return this.httpClient
      .post(this.Customeroutes.leaveFilter(), postBody, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


}
